import { forwardRef } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: React.ReactNode;
  width: string;
};

const Modal = forwardRef<HTMLDivElement, Props>(({ children, width }, ref) => {
  return createPortal(
    <>
      <div className='relative z-[9999]'>
        <div className='fixed inset-0 z-40 bg-black opacity-30'></div>
        <div className='fixed inset-0 z-50 grid place-items-center'>
          <div
            ref={ref}
            className={`relative flex max-h-[88vh] w-full flex-col overflow-y-auto rounded bg-white shadow-[0_0_8px_rgba(0,0,0,0.25)] lg:w-[95%]`}
            style={{ maxWidth: width }}
          >
            {children}
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
});

export default Modal;
